import React from 'react';
import { Button } from '@/components/common/Button';
import { useTranslation } from 'react-i18next';

interface NumericKeypadProps {
  onKeyPress: (key: string) => void;
  onClear: () => void;
  onBackspace: () => void;
}

const NumericKeypad: React.FC<NumericKeypadProps> = ({ onKeyPress, onClear, onBackspace }) => {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-3 gap-2 mt-4">
      {keys.map((key) => (
        <Button
          key={key}
          onClick={() => onKeyPress(key)}
          variant="outline"
          className="h-14 text-xl font-semibold"
        >
          {key}
        </Button>
      ))}
      <Button onClick={onClear} variant="secondary" className="h-14">
        {t('clear')}
      </Button>
      <Button key={0} onClick={() => onKeyPress('0')} variant="outline" className="h-14 text-xl font-semibold">
        0
      </Button>
      <Button onClick={onBackspace} variant="secondary" className="h-14">
        ⌫
      </Button>
    </div>
  );
};

export default NumericKeypad;